import { Padding } from '@mui/icons-material';
import {
  Typography, TextField, Grid, FormControl,
  FormLabel, FormHelperText, Button, Paper,
  Container, Box, Checkbox, FormControlLabel
} from '@mui/material'
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicRoutes } from '../../routes';
import { useSelector } from 'react-redux';
import { AppStore } from '../../redux/stores';

const clases = {
  root: {
    p: 4
  },
  textCenter: {
    textAlign: 'center'
  },
  form: {
    p: 2
  },
  toggleButton: {
    width: '50%'
  },

  formcontrol: {
    mt: 2,
    mb: 1.5
  },

  boton: {
    mt: 1.5,
    mb: 3
  }
}

export default function SinProductos() {

  const navigate = useNavigate();
  function regresar() {
    navigate(`/${PublicRoutes.INICIO}`, { replace: true });
  }
  //Recuperar el idError
  const error = useSelector((state: AppStore) => state.error.idError);
  //Recuperar el idTramite
  const userIdTramite = useSelector((state: AppStore) => state.user.idTramite);

  return (
    <Container maxWidth='md'>
      <Grid container direction='column' alignItems='center' justifyContent='center' padding='30px 30px'>
        <Grid item>
          <Paper sx={{ padding: '1.2em', mt: '1.5em' }}>
            <Typography variant="h4" color="initial" sx={clases.textCenter}>POR EL MOMENTO NO TENEMOS UN PRODUCTO ADECUADO PARA VOS</Typography>
            <Typography variant="h5" color="initial" sx={clases.textCenter}>Por favor acércate a alguna de nuestras sucursales.</Typography>
            <br />
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ textAlign: 'center', fontSize: '0.9rem' }}
            >
              {/* (Error: {error} - N° de Tramite: {userIdTramite}) */}
            </Typography>
            <Grid container direction='column' alignItems='center' justifyContent='flex-end'>
              <Grid item>
                <Button color='primary' variant='contained' type='submit' sx={clases.boton} onClick={regresar}>Regresar</Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}